import ItemsI from '../types.ts';

const getParentForScroll: ItemsI['getParentForScroll'] = function () {
    return this.parent.current?.querySelector('._SCROLLPARENT');
};

export default getParentForScroll;
